import React from 'react';

import { Tag, Text } from '@chakra-ui/react';

interface LiveTagProps {
  isLive: boolean;
}

export const LiveTag: React.FC<LiveTagProps> = ({ isLive }) => (
  <Tag
    width="160px"
    transform="rotate(-45deg)"
    textAlign="center"
    fontSize="xl"
    colorScheme={isLive ? 'green' : 'yellow'}
    zIndex={6}
    position="absolute"
    bottom="33px"
    right="-35px"
    alignItems="center"
    justifyContent="center"
  >
    <Text>{isLive ? 'LIVE' : 'IN KÜRZE'}</Text>
  </Tag>
);
